import { NoRecordsImage } from '@root/src/assets/images';
import styled from 'styled-components';
import colors from '@designSystem/colors';
import { Paragraph } from '@designSystem/typings';
import { TableContainer } from '@app/common/DataTable/styles';

export const OrdersTableContainer = styled(TableContainer)`
  min-height: auto;

  & table {
    margin-top: 16px;
  }

  & th {
    &:first-child {
      width: 72px;
    }
  }

  & td {
    &:first-child {
      padding-left: 24px;

      & > svg {
        display: block;
      }
    }
  }
`;

export const ListRow = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;

  cursor: pointer;

  font-family: arial;
  margin: 8px 0px;
  padding-left: 30px;
  height: 92px;
  min-height: 92px;
  background: ${colors.white};
  border-radius: 4px;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > svg {
    width: 12px;
    height: 12px;
  }
`;

export const NameRow = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: ${colors.black};

  padding-left: 14px;
`;

export const TestTypeRow = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.darkGrey};

  padding-left: 26px;
`;

export const LastUpdatedRow = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.grey};
  padding-left: 16px;
`;

export const ClickableIcon = styled.div`
  cursor: pointer;
`;

export const NoRecordsImageWithMargin = styled(NoRecordsImage)`
  margin: 40px 0px;
`;

export const ParagraphWithMargin = styled(Paragraph)`
  margin: 8px 0px;
`;

export const NoRecordsFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const List = styled.ul`
  padding: 0px;
`;
